export const initialData = {
  init: false,
  fields: {
    FirmFundHistoryID: null,
    FirmID: 0,
    FundName: '',
    FundNumber: 0,
    FundNumberType: null,
    Vintage: null,
    FirmFundFocusID: null,
    Geography: '',
    Returns: null,
  },
  options: {
    FundNumberType: [],
    FirmFundFocusID: [],
    Vintage: [],
  },
};
